import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SharedModule } from 'primeng/api';
import { AiTableSearchComponent } from './ai-table-search.component';

@NgModule({
  imports: [CommonModule, FormsModule, InputTextModule, TooltipModule, SelectButtonModule, SharedModule],
  declarations: [AiTableSearchComponent],
  exports: [AiTableSearchComponent],
})
export class AiTableSearchModule {}
